'use strict';
 

/**
 * 
 * @param {*} localCollect 
 * Update the values of royal mail shipping address based on the local storage value
 * 
 */
function updateRoyalMailShippingAddress(thisShipping) {
    var shippingId = thisShipping.attr('value');
    if (localStorage['royalMail-edit_'+shippingId] && localStorage.getItem('storedAddressData') != null) {
        var old_storedAddressData = JSON.parse(localStorage.getItem('storedAddressData'));
        var localCollectValues = old_storedAddressData[shippingId];
        var countryCode = fetchCountryCode();
        thisShipping.parent().find('.address-line1').html(localCollectValues.addressLine1);
        thisShipping.parent().find('.address-line2').html('');
        thisShipping.parent().find('.store-details-royalMail-section .postal').html(localCollectValues.postcode);
        thisShipping.parent().find('.store-details-royalMail-section .city').html(localCollectValues.city);
        thisShipping.parent().find('.store-details-royalMail-section .country').html(countryCode);
        thisShipping.parent().find('.store-royalMail-details').addClass('active');
        thisShipping.parent().find('.store-details-royalMail-section').addClass('filled');
        if (!thisShipping.parent().find('.store-details-royalMail-section').is(':empty')) {
            thisShipping.parent('.shipping-method').addClass("edit-btn-active");
        }
        setRoyalMailAddLabel(localCollectValues); 
    }
}

function renderRoyalMail(thisShipping) {
    let rmCollectionID = $("#rmCollectionID").val(),
     rmCollectionKey = $('#rmCollectionKey').val(),
     rmCollectionMapsKey = $('#rmCollectionMapsKey').val();

     $("body, html").addClass("royalmail-scroll-hidden");
     setTimeout(() => {
        if(!$(".widgfooter").hasClass('widgetbutton')){
            $(".widgfooter").append('Cancel');
            $(".widgfooter").addClass('widgetbutton');
        } 
        
        if ($('.widgetSearchButton').length == 0) {
            $('#widgetSearchButton').after(
                $('<div>')
                    .addClass('widgetSearchButton')
                    .append(
                        $('<span>').addClass('text-label').text($('#widgetSearchButton').val()), // Create a span with the input's value as text
                        $('<span>').addClass('icon icon-search') // Add a span for the icon
                    )
            );
        } 

        $('.royalMail-wrapper .widgfooter').on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeRoyalMailPopup();
            if($("input:radio.shipping-method-input:checked").hasClass('royal-mail-method') && $('.store-details-royalMail-section .address-line1').is(':empty')) {
                $('input:radio.shipping-method-input').each(function() {
                    if(!$(this).hasClass('royal-mail-method')) {
                        $(this).trigger('click');
                        return false; // break loop
                    }
                });     
            }
        });

        $(document).on('click','#enableGpsChBx',function (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        });
        

        //Prevent the trigger of shipping method on click of Map canvas in popup
        $(document).on('click','#royalMailLocalCollectPlaceHolder',function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
         });
 
         
         $(document).on('click','.mapSection',function (e) {
             e.preventDefault();
             e.stopImmediatePropagation();
         });
     }, 2000);

     setTimeout(() => {
        if($('.widgetInput').val() != '') {
            $('.postCode-lab').parent('.postCodeContainer').addClass('focused');
            $(this).addClass('addTick');
        } else {
            $(this).removeClass('addTick');
        }

        $('.widgetInput').on('focus', function (){
            $('.postCode-lab').parent('.postCodeContainer').addClass('focused');
                $(this).addClass('addTick');
        });
        
        $('.widgetInput').on('blur', function (){
            if(!$(this).val()) {
              $('.postCode-lab').parent('.postCodeContainer').removeClass('focused');
              $(this).removeClass('addTick');
            } else {
                $(this).addClass('addTick');
            }
        });
        
        //add the error message after geolocation checkobox
        if($(window).width() < 789){
            $('.postCodeContainer').after($('#notificationRegion'));
        } else {
            $('.postCodeContainer').before($('#notificationRegion'));
        }

        //add close icon 
        if(!$('.widgetTitle').find('.royalMail-close').length) {
            $('.widgetTitle').append('<i class="royalMail-close icon-close"></i>');
        }
    }, 500);

    // Show the local collect search results on pressing enter key on Post Code input box
    setTimeout(() => {
    $('#localCollectPostalCode').on('keypress', function (e) {
        var key = e.which;
        if(key == 13)  // the enter key code
        {
            $('#widgetSearchButton').trigger('click');
        return false;
        }
    });      

    $('#widgetSearchButton').on('click', function (e) {
        setTimeout(() => {
            $('.locationsFoundContainer').addClass('show');
        }, 2000);
    });  

    }, 1000);

    let widgetConfigObj = {
        // Grid or Maps pr 'DropDown'
        viewingOptions:['Maps'],
        royalMail: { getRMId: function () { return rmCollectionID } },
        deliveryPostCode: fetchPostalCode(thisShipping),
        defaultRadius: 10,
        defaultNbrOfResults: 10,
        getRMId: function () { return rmCollectionID },
        getRMKey: function () { return rmCollectionKey }, 
        getMapsKey: function () { return rmCollectionMapsKey },
        onOpenWidget: function () {
        },
        onLocationSelected : function(localCollect) { 	        
            var shippingId  = thisShipping.attr('value');         
            if(localStorage.getItem('storedAddressData') == null){
                localStorage.setItem('storedAddressData','{}'); 
            }
            var old_storedAddressData = JSON.parse(localStorage.getItem('storedAddressData'));
            old_storedAddressData[shippingId] = localCollect;
            localStorage.setItem('storedAddressData', JSON.stringify(old_storedAddressData));    
            localStorage['royalMail-edit_'+shippingId]='active';
            $('#pickupStore_storeAddress1').val(localCollect.addressLine1);
            $('#pickupStore_storeAddress2').val('');
            $('#pickupStore_storeAddressPostal').val(localCollect.postcode);
            $('#pickupStore_storeAddressCity').val(localCollect.city);
            var countryCode = fetchCountryCode();
            $('#pickupStore_storeAddressCountry').val(countryCode);
            updateRoyalMailShippingAddress(thisShipping);
        },
          onCancelSelection : function() {
          }
    }
    return widgetConfigObj;
}

function setPickupStoreValue(thisShipping) {
    var shippingId = thisShipping.attr('value');
    if(localStorage.getItem('storedAddressData') != null){
        var old_storedAddressData = JSON.parse(localStorage.getItem('storedAddressData'));
        var localCollectValues = old_storedAddressData[shippingId];
        $('#pickupStore_storeAddress1').val(localCollectValues.addressLine1);
        $('#pickupStore_storeAddress2').val('');
        $('#pickupStore_storeAddressPostal').val(localCollectValues.postcode);
        $('#pickupStore_storeAddressCity').val(localCollectValues.city);
        var countryCode = fetchCountryCode();
        $('#pickupStore_storeAddressCountry').val(countryCode);
        setRoyalMailAddLabel(localCollectValues); 
    }
}

function setRoyalMailAddLabel(localCollectValues){
    if(localCollectValues && 'locationType' in localCollectValues){
        let pickupStoreLabel = 'c/o '+ localCollectValues.locationType +' '+ localCollectValues.labelID +' '+ localCollectValues.locationName;
        pickupStoreLabel = pickupStoreLabel.replace(/\s+/g, ' ');
        $('#pickupStore_storeAddressLabel').val(pickupStoreLabel);
    }    
}

function fetchPostalCode(thisShipping) {
	var postalCode = '';
    var shippingID = thisShipping.attr('value');
        if (thisShipping.parent().find(".store-details-royalMail-section").hasClass("filled") && localStorage.getItem('storedAddressData') != null) {
            var old_storedAddressData = JSON.parse(localStorage.getItem('storedAddressData'));
            var localCollectValues = old_storedAddressData[shippingID];
            postalCode = localCollectValues.postcode;
        } else {
            if ($(".address-tile").length > 0) {
                  postalCode = $(".address-tile.selected")
                    .find(".mini-address-wrapper")
                    .data("postalCode");
              } else {
                postalCode = $('.input-text.postal').val();
              }
        }
	return postalCode;
}

// Close Mondial Relay Popup 
function closeRoyalMailPopup() {
    $("body, html").removeClass("royalmail-scroll-hidden");
    $('.royalMail-overlay').css('display', 'none');
    // $('#royalMailLocalCollectPlaceHolder:empty').length > 0 && $('.royalMail-overlay').css('display', 'none');
    $(".royalMail-wrapper").removeClass("active");
}

function fetchCountryCode() {
    var userLocale = window.User.locale;
    var countryCode = 'GB';
    if (userLocale !== null && userLocale.split('_').length === 2) {
        countryCode = userLocale.split('_')[1];
    }
    return countryCode;
}

export default{ renderRoyalMail, updateRoyalMailShippingAddress, closeRoyalMailPopup, setPickupStoreValue };
